module.exports = __webpack_public_path__ + "img/wenhuashengzhuce1.0951c7a0.png";